module.exports = __webpack_public_path__ + "static/media/edit.39d53035.svg";